<template>
    <div id="OfflineRequestArchives">
        <ArchiveComponent
            :fetch-callback="getOfflineSupportRequests"
            :is-archive="false"
            :selected-time="timeSelect"
            :table-data="offlineSupportRequests.data"
        >
        </ArchiveComponent>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ArchiveComponent from "./ArchiveComponent";

export default {
    name: "OfflineRequestArchives",
    components: {
        ArchiveComponent,
    },
    props: ["timeSelect"],
    computed: {
        ...mapState({
            offlineSupportRequests: (state) => state.offlineSupportRequest.offlineSupportRequests,
        }),
    },
    methods: {
        ...mapActions({
            getOfflineSupportRequests: "offlineSupportRequest/getOfflineSupportRequests",
        }),
    },
};
</script>

<style lang="scss" scoped></style>
